module.exports = __webpack_public_path__ + "img/selected7-min.cbc3c875.png";